<template>
  <div class="popup">
    <div class="bg-modal"></div>
    <div class="common-alert alert">
      <div class="alert-tlt">
        <p>{{ targetName }} 수정</p>
        <button class="btn-close" @click="closeModal">
          <img src="/static/img/ico-close.png" alt />
        </button>
      </div>
      <div class="alert-desc">
        <div class="row-group">
          <div class="info-row">
            <h3 class="info-tlt">회사 이름</h3>
            <span v-if="target === 'company'" class="info-box">
              <input type="text" v-model="company.companyName" />
            </span>
            <span v-else class="info-box text">
              {{ companyName }}
            </span>
          </div>
          <div v-if="target === 'company'" class="info-row">
            <h3 class="info-tlt">사업자번호</h3>
            <span class="info-box">
              <input type="text" v-model="company.registrationNo" />
            </span>
          </div>
          <div v-if="target === 'company'" class="info-row info-select">
            <h3 class="info-tlt">역할</h3>
            <select v-model="company.scope">
              <option v-for="item in $companyScope" :key="item.code" :value="item.code">
                {{ item.name }}
              </option>
            </select>
          </div>
          <div v-if="target !== 'company'" class="info-row">
            <h3 class="info-tlt">부서 이름</h3>
            <span v-if="target === 'division'" class="info-box">
              <input type="text" v-model="division.divisionName" />
            </span>
            <span v-else class="info-box text">
              {{ divisionName }}
            </span>
          </div>
          <div v-if="target === 'user'" class="info-row">
            <h3 class="info-tlt">사용자 ID</h3>
            <span class="info-box text">
              {{ user.userID }}
            </span>
          </div>
          <div v-if="target === 'user'" class="info-row">
            <h3 class="info-tlt">비밀번호</h3>
            <span class="info-box">
              <input type="password" v-model="user.passwd" />
            </span>
          </div>
          <div v-if="target === 'user'" class="info-row">
            <h3 class="info-tlt">사용자 이름</h3>
            <span class="info-box">
              <input type="text" v-model="user.name" />
            </span>
          </div>
          <div v-if="target === 'user'" class="info-row">
            <h3 class="info-tlt">이메일 주소</h3>
            <span class="info-box">
              <input type="text" v-model="user.email" />
            </span>
          </div>
          <div v-if="target === 'user'" class="info-row">
            <h3 class="info-tlt">핸드폰 번호</h3>
            <span class="info-box">
              <input type="text" v-model="user.mobile" />
            </span>
          </div>
          <div v-if="target === 'user'" class="info-row info-select">
            <h3 class="info-tlt">역할</h3>
            <span class="info-box">
              <select v-model="user.role">
                <option v-for="item in userRole" :key="item.code" :value="item.code">
                  {{ item.name }}
                </option>
              </select>
            </span>
          </div>
        </div>
      </div>
      <div class="alert-btn alert-btn-2">
        <button class="btn-green-line btn-default" @click="closeModal">취소</button>
        <button class="btn-green btn-default" @click="excuteUpdate">수정</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-plusplus */
import Configuration from '@/js/Configuration';

export default {
  props: [
    'target',
    'companyID',
    'companyName',
    'divisionID',
    'divisionName',
    'company',
    'division',
    'user',
  ],
  data: () => ({
    userRole: [],
  }),
  computed: {
    targetName() {
      let result = null;

      if (this.target === 'company') {
        result = '회사';
      } else if (this.target === 'division') {
        result = '부서';
      } else if (this.target === 'user') {
        result = '사용자';
      }

      return result;
    },
  },
  created() {
    for (let i = 0; i < this.$userRole.length; i++) {
      if (i !== 0) {
        this.userRole.push(this.$userRole[i]);
      }
    }
  },
  methods: {
    async excuteUpdate() {
      let createUrl = `${Configuration.value(
        'CACCOUNT_ADDRESS',
      )}/api/v1/caccount/${this.target}`;

      let param = null;
      if (this.target === 'company') {
        createUrl = `${createUrl}/${this.company.companyID}`;
        param = this.company;
      } else if (this.target === 'division') {
        createUrl = `${createUrl}/${this.division.divisionID}`;
        this.division.companyID = this.companyID;
        param = this.division;
      } else if (this.target === 'user') {
        createUrl = `${createUrl}/${this.user.uID}`;
        const encPass = this.$jsEncrypt.encrypt(this.user.passwd);
        this.user.passwd = encPass;
        if (this.user.role === 2) { // manager
          this.user.manager = {
            divisionID: this.divisionID,
          };
        } else if (this.user.role === 3) { // operator
          this.user.operator = {
            divisionID: this.divisionID,
          };
        } else if (this.user.role === 4) { // monitor
          this.user.monitor = {
            divisionID: this.divisionID,
          };
        }
        param = this.user;
      }

      const createResult = await this.$http.put(createUrl,
        param,
        {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
      if (createResult.status !== 200) {
        throw new Error(`Response status is "${createResult.status}"`);
      }
      if (createResult.data.resultCode !== '0000') {
        throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
      }

      this.$emit('updateComplete');
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style scoped>
.popup{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.bg-modal{
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
}
.alert{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 4px;
  padding: 0 16px;
  width: auto;
}

.alert-tlt{
  width: 100%;
/*  height: 34px;*/
  height: 38px;
  border-bottom: 0.5px solid #8B9296;
/*  padding-top: 12px;*/
  padding-top: 14px;
  overflow: hidden;
}
.alert-tlt p{
  font-size: 12px;
  color: #8B9296;
  float: left;
}
.alert-tlt .btn-close{
  width: 14px;
  height: 14px;
  float: right;
  opacity: 38%;
  cursor: pointer;
}
.alert-tlt .btn-close img{
  width: 100%;
}
.alert-desc{
  width: 100%;
  height: auto;
  margin-top: 16px;
}

.alert-btn{
  overflow: hidden;
  height: 40px;
  margin: 24px auto;
}
.alert-btn button{
  float: left;
  height: 100%;
/*  width: 100%;*/
  text-align: center;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}
.common-alert {
  width: 392px;
  height: auto;
}
.btn-green{
  border: 1px solid #38b78f;
  background-color: #38b78f;
  color: #fff;
}
.btn-green-line{
  border: 1px solid #38b78f;
  color: #38b78f;
}
.btn-blue{
  border: 1px solid #3aa7b1;
  background-color: #3aa7b1;
  color: #fff;
}
.btn-blue-line{
  border: 1px solid #3aa7b1;
  color: #3aa7b1;
}
.btn-gray{
  border: 1px solid #d7dadb;
  background-color: #d7dadb;
  color: #fff;
}
.btn-gray-line{
  border: 1px solid #8B9296;
  color: #8B9296;
}
.btn-red{
  border: 1px solid #F44336;
  background-color: #F44336;
  color: #fff;
}
.btn-red-line{
  border: 1px solid #F44336;
  color: #F44336;
}
.btn-default{
  transition: 0.3s;
}
.btn-default:hover{
  border: 1px solid #263339;
  background-color: #263339;
  color: #fff;
}
.alert-btn-2{
  width: 216px;
}
.alert-btn-2 button{
  width: 100px;
}
.alert-btn-2 button:first-child{}
.alert-btn-2 button:last-child{
  margin-left: 16px;
}
.row-group{
  width: 100%;
  height: auto;
}
.row-group .info-row{
  width: 100%;
}
.info-row .info-tlt{
  font-size: 14px;
  font-weight: 500;
}
.info-row .info-box{
  display: block;
  width: 100%;
  height: 46px;
  border-radius: 4px;
  border: solid 1px #d7dadb;
  background-color: #ffffff;
  margin: 8px 0;
}
.info-row .info-box input{
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  padding: 13px 12px;
  font-size: 14px;
}
.info-row .info-box.text{
  padding: 13px 12px;
}
.info-row .info-box select {
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  padding: 13px 12px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/account/UpdateModal.vue